import type {ReactNode} from 'react';
import {PureComponent} from 'react';

type Props = {
    isReadOnly: boolean;
    fallback?: ReactNode;
    children?: ReactNode;
}

export class HideWhenChannelIsReadOnly extends PureComponent<Props> {
    render() {
        if (this.props.isReadOnly) {
            return Boolean(this.props.fallback) && this.props.fallback;
        }

        return Boolean(this.props.children) && this.props.children;
    }
}
